import cn from 'classnames';

import { Icon, Typography } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { Info } from '@src/components/icons/info';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';

import { catPawIcon, catServiceOneIcon, coinsImage, cupImage } from '../assets';

import styles from './ServiceBanner.module.scss';
import { ServiceBannerInfoSheetSheet } from './ServiceBannerInfoSheet/ServiceBannerInfoSheet';

export function ServiceBanner() {
  const [isShown, setIsShown] = useBoolean();
  return (
    <div className={styles.container}>
      <img className={styles.coins} src={coinsImage} alt="" />
      <img src={catServiceOneIcon} className={styles.commonImage} alt="" />
      <img className={styles.paw} src={catPawIcon} alt="" />
      <OptimizedPicture img={cupImage} className={cn(styles.cubok)} alt="" />
      <div className={styles.card}>
        <Typography.Text className={styles.text}>Сравни{UNBREAKABLE_SEPARATOR}— сервис №1 по займам</Typography.Text>
        <Icon icon={<Info />} onClick={setIsShown.on} />
      </div>
      <ServiceBannerInfoSheetSheet visible={isShown} onClose={setIsShown.off} onButtonClick={setIsShown.off} />
    </div>
  );
}
